module.exports = __webpack_public_path__ + "img/info.2b9cb32a.svg";